import { useState, useEffect } from "react";

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    let resizeTimer = null;

    const handleResize = () => {
      // Use requestAnimationFrame to avoid ResizeObserver loop issues
      if (resizeTimer !== null) {
        cancelAnimationFrame(resizeTimer);
      }

      resizeTimer = requestAnimationFrame(() => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      });
    };

    // Attach the resize event listener
    window.addEventListener("resize", handleResize);

    // Initialize the size on mount
    handleResize();

    // Cleanup the listener and timer
    return () => {
      if (resizeTimer !== null) {
        cancelAnimationFrame(resizeTimer);
      }
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
};
